
// Autogenerated
// -------------
// gulpfile.ts/wasm.ts --> generateBuildInfo

export const Build = {
    short: "0.71.7",
    version: "0.71.7 (6e5a984743bbee490bb8611add5a5a3c)",
    buildSeed: 1630921140124,
};
